//
//
//
//
//

import ChatFeed from '../components/chat-feed'
export default {
  components: {ChatFeed},
  name: 'basics',
  data () {
    return {}
  },
  methods: {},
  computed: {}
}



// WEBPACK FOOTER //
// ./src/pages/basics.vue